module.exports = __webpack_public_path__ + "static/media/introTeams.2edaca39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/introTeams.jpg
// module id = 857
// module chunks = 9